const nullifyCutOffTime = (import.meta.env.VITE_NULLIFY_CUTOFF_TIME as string) ?? '23:59:59'

const toPstDate = (date: Date) => {
  return new Date(
    date.toLocaleString('en-US', {
      timeZone: 'America/Los_Angeles',
    })
  )
}

export const isClaimNullifyPeriodExpired = (lastModified: string): boolean => {
  let submitDate = toPstDate(new Date(lastModified))
  const nullifyCutoffDate = toPstDate(new Date())
  const nullifyCutoffTime = nullifyCutOffTime.split(':')
  nullifyCutoffDate.setHours(
    parseInt(nullifyCutoffTime[0]),
    parseInt(nullifyCutoffTime[1]),
    parseInt(nullifyCutoffTime[2]),
    999
  )
  const now = toPstDate(new Date())
  return now > nullifyCutoffDate || now.toDateString() !== submitDate.toDateString()
}
